import {
  DELIVERY_FEE_LABEL,
  DELIVERY_FEE_HELP,
} from 'src/utils/deliveryFeeCopy'
import { Input, Select, Form } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'
import { useSelector } from 'react-redux'
import DeliveryDaysSelect from 'src/components/DeliveryDaysField'
const { Option } = Select
const CustomerCard = ({
  addingCustomer,
  setAddingCustomer,
  getFieldDecorator,
}) => {
  const account = useSelector(state => state.auth.account)
  const suppliers = account.supplier

  const handleSupplierChange = value => {
    setAddingCustomer(prev => ({
      ...prev,
      supplierid: value,
    }))
  }
  return (
    <Form>
      <CardComp>
        <FormItem>
          {getFieldDecorator('emailOfCustomer', {
            rules: [
              {
                required: true,
                message: 'Please input email of customer',
              },
              {
                type: 'email',
                message: 'The input is not valid email',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.emailOfCustomer}
              addonBefore={'Email of Customer'}
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  emailOfCustomer: e.target.value,
                })
              }}
              placeholder='Email of Customer'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('accountName', {
            rules: [
              {
                required: true,
                message: 'Please input account name',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.accountName}
              addonBefore={'Account Name'}
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  accountName: e.target.value,
                })
              }}
              placeholder='Account Name'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('venueName', {
            rules: [
              {
                required: true,
                message: 'Please input venue name',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.venueName}
              addonBefore='Venue Name'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  venueName: e.target.value,
                })
              }}
              placeholder='Venue Name'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('accountNumber', {
            rules: [
              {
                required: true,
                message: 'Please input account number',
              },
              {
                pattern: /^\d+$/,
                message: 'The account number must be a positive number!',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.accountNumber}
              addonBefore='Account Number'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  accountNumber: e.target.value,
                })
              }}
              placeholder='Account Number'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('addressCity', {
            rules: [
              {
                required: true,
                message: 'Please input address city',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.addressCity}
              addonBefore='Address City'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  addressCity: e.target.value,
                })
              }}
              placeholder='Address City'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('addressLine1', {
            rules: [
              {
                required: true,
                message: 'Please input address line 1',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.addressLine1}
              addonBefore='Address Line 1'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  addressLine1: e.target.value,
                })
              }}
              placeholder='Address Line 1'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('addressLine2', {
            rules: [
              {
                required: true,
                message: 'Please input address line 2',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.addressLine2}
              addonBefore='Address Line 2'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  addressLine2: e.target.value,
                })
              }}
              placeholder='Address Line 2'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('addressPostCode', {
            rules: [
              {
                required: true,
                message: 'Please input address post code',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.addressPostCode}
              addonBefore='Address Post Code'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  addressPostCode: e.target.value,
                })
              }}
              placeholder='Address Post Code'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('minimumOrder', {
            rules: [
              {
                required: true,
                message: 'Please input minimum order',
              },
              {
                pattern: /^\d+$/,
                message: 'The minimum order must be a positive number!',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.minimumOrder}
              addonBefore='Minimum Order'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  minimumOrder: e.target.value,
                })
              }}
              placeholder='Minimum Order'
            />,
          )}
        </FormItem>

        <FormItem label={DELIVERY_FEE_LABEL} extra={DELIVERY_FEE_HELP}>
          {getFieldDecorator('deliveryFee', {
            initialValue: (
              Number(addingCustomer.deliveryFee || 0) / 100
            ).toFixed(2),
            rules: [
              {
                required: true,
                message: 'Please input delivery fee',
              },
              {
                pattern: /^\d+(\.\d{1,2})?$/,
                message:
                  'Enter zero or a positive amount with up to 2 decimal places.',
              },
            ],
          })(
            <InputComp
              prefix='£'
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  // The legacy admin API stores this field in pennies.
                  deliveryFee: Math.round(Number(e.target.value || 0) * 100),
                })
              }}
              placeholder='0.00'
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('deliveryDays', {
            rules: [
              {
                required: true,
                message: 'Please select the delivery days',
              },
            ],
          })(
            <DeliveryDaysSelect
              deliveryDays={addingCustomer.deliveryDays}
              onChange={value => {
                setAddingCustomer({ ...addingCustomer, deliveryDays: value })
              }}
              isDisabled={false}
            />,
          )}
        </FormItem>

        <FormItem>
          {getFieldDecorator('orderCutOffTime', {
            rules: [
              {
                required: true,
                message: 'Please input the order cut off time',
              },
            ],
          })(
            <InputComp
              value={addingCustomer.orderCutOffTime}
              onChange={e => {
                setAddingCustomer({
                  ...addingCustomer,
                  orderCutOffTime: e.target.value,
                })
              }}
              addonBefore={'Order cut off time'}
              placeholder='Order cut off time'
            />,
          )}
        </FormItem>

        <FormItem>
          <StyledDiv>
            <span>Price File</span>
            <Select
              allowClear
              placeholder='Price File'
              style={{ width: '81%' }}
              onChange={handleSupplierChange}
            >
              {suppliers.map(supplier => {
                return (
                  <Option key={supplier._id} value={supplier._id}>
                    {supplier.title + ' ' + supplier.secondTitle}
                  </Option>
                )
              })}
            </Select>
          </StyledDiv>
        </FormItem>
      </CardComp>
    </Form>
  )
}

const CardComp = styled.div`
  width: 470px;
`

const InputComp = styled(Input)`
  // margin-bottom: 12px;
`

const StyledDiv = styled.div`
  margin-bottom: 12px;
  span {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding: 4px 10px;
    max-height: 32px;
    border: 1px solid ${({ theme }) => theme.colours.panSilver};
    background-color: ${({ theme }) => theme.colours.bgGrey};
  }
  display: flex;
`

const FormItem = styled(Form.Item)`
  margin-bottom: 12px !important;
`

export default CustomerCard
